import React from "react";

/**
 * Editorial hero badge — matches the home-page treatment:
 * thin gradient line · pulsing dot · uppercase tracked-out label · thin gradient line
 *
 * Usage:
 *   <HeroBadge>About Nirmal Hospital · <span className="text-[#A53A2A]">Adajan</span></HeroBadge>
 */
export default function HeroBadge({ children, dotColor = "#1F7A3D" }) {
  return (
    <div className="fade-up inline-flex items-center gap-3" data-testid="hero-badge">
      <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#A53A2A]" />
      <span className="relative flex h-2 w-2">
        <span
          className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping"
          style={{ background: dotColor }}
        />
        <span
          className="relative inline-flex rounded-full h-2 w-2"
          style={{ background: dotColor }}
        />
      </span>
      <span className="text-[11px] uppercase tracking-[0.32em] font-semibold text-[#0F2540] whitespace-nowrap">
        {children}
      </span>
      <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#A53A2A]" />
    </div>
  );
}
